<template>
  <div class="ldetailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading" @resize="handleResize">
    <div class="banner">
      <swiper :options="swiperOption">
        <swiper-slide class="swiper-slide"  v-for="(vo,i) in setLuggage.image">
          <img :src="baseUrl+vo" style="width:100%;height:240px;object-fit: cover;">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="proCon">
      <div class="cost">
        <div class="hot">
          <h1>会员福利抢购</h1>
          <p><span><font>原价￥</font>{{setLuggage.price}}</span><span><font>折后价</font>{{setLuggage.rate}}</span></p>
        </div>
        <div class="timer">
          <p>每日营业时间</p>
          <a>{{setLuggage.initial.business}}</a>
        </div>
      </div>
      <h2>
        <div class="names">{{setLuggage.title}}</div>
        <p>销量：{{setLuggage.total}}</p>
      </h2>
    </div>
    <div class="infoCon">
      <h2>路线规划图</h2>
      <el-timeline>
        <el-timeline-item timestamp="起始端" placement="top" icon="el-icon-success" type="primary" color="#fff" size="large">
          <div class="initial">
            <h4>{{setLuggage.initial.title}}</h4>
            <p>营业时间：{{setLuggage.initial.business}}</p>
            <em class="el-icon-check"></em>
          </div>
        </el-timeline-item>
        <el-timeline-item timestamp="目的地" placement="top" icon="el-icon-success" type="primary" color="#fff" size="large">
          <div class="initial" v-for="(vo,i) in setPurpose" @click="initial = vo.id">
            <h4>{{vo.title}}</h4>
            <p>{{vo.address}}</p>
            <em :class="initial == vo.id ? 'el-icon-check' : 'borders'"></em>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
    <div class="infoCon" style="margin-bottom:1px">
      <h2 style="font-weight:normal;font-size:15px" @click="drawer = true"><font style="color:#969799;padding-right:8px">规格</font> 请选择规格及数量
        <a><i class="el-icon-arrow-right"></i></a>
      </h2>
    </div>
    <div class="infoCon" style="padding-bottom:12px">
      <h2>服务说明</h2>
      <div class="xc" v-html="setLuggage.content"></div>
    </div>
    <div :style="bool == 1 ? 'height:98px' : 'height:72px'"></div>
    <div class="proFooter" :style="bool == 1 ? 'padding-bottom:22px' : 'padding-bottom:0px'">
      <div class="left">
        <p @click="$router.push('index')">
          <i class="el-icon-s-home"></i>
          <span>首页</span>
        </p>
        <p>
          <a href="tel:18177968850" style="text-decoration: none"><i class="el-icon-chat-dot-round"></i>
          <span>客服</span></a>
        </p>
        <p @click="$router.push('lorder')" style="width:40%">
          <i class="el-icon-document"></i>
          <span>我的订单</span>
        </p>
      </div>
      <div class="right">
        <a @click="drawer = true">立即下单</a>
      </div>
    </div>

    <el-drawer title="" :visible.sync="drawer" size="60%" :direction="direction" :withHeader="false" :show-close="true" :wrapperClosable="false">
      <dl class="proList">
        <dd>
          <div class="fmt">
            <el-image style="width:100%;height:85px; border-radius:5px;" :src="baseUrl+setLuggage.image[0]" fit="cover"></el-image>
          </div>
          <div class="right">
            <h2>{{setLuggage.title}}</h2>
            <div class="sales">销量：{{setLuggage.total}}</div>
            <div class="price"><span>￥{{setLuggage.rate}}</span></div>
          </div>
          <i class="el-icon-close" @click="drawer = false"></i>
        </dd>
      </dl>
      <div class="norm">
        <h2>规格</h2>
        <ul>
          <li class="curt">默认规格</li>
        </ul>
        <div class="addnum">
          <font>购买数量：</font>
          <div class="cnum">
          <span class="el-icon-remove-outline" @click="num = (num == 1 ? 1 : num-1)"></span>
          <span class="num">{{num}}</span>
          <span class="el-icon-circle-plus" @click="num = num+1"></span>
          </div>
        </div>
      </div>
      <div class="btnYes" @click="yesPayment">
        <a>确认</a>
      </div>
    </el-drawer>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        drawer:false,
        direction: 'btt',
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        swiperOption: {
          autoplay : {
            disableOnInteraction: false,
            delay: 5000
          },
          initialSlide: 0,
          speed: 1000,
          loop:true,
          grabCursor: true,
          autoHeight: true,   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true,
          observeParents: true,
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },
        },
        bool:0,
        setLuggage:[],
        setPurpose:[],
        initial:'',
        num:1,
        code:'',
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      window.removeEventListener("resize", this.handleResize);
    },
    mounted() {
      this.beforeMount();
      window.addEventListener("resize", this.handleResize);
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        var id = this.$route.query.id
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/ldetail?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
        this.getLuggage();
        this.getPurpose();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
        this.bool = (h >= 800 && this.isPhone() ? 1 : 0);
      },
      handleResize:function(e){
        if(this.curHeight < e.currentTarget.innerHeight && this.isPhone()){
          this.bool = 1;
        }else {
          if(this.curHeight >= 800 && this.curHeight == e.currentTarget.innerHeight && this.isPhone()){
            this.bool = 1;
          }else{
            this.bool = 0;
          }
        }
      },
      isPhone:function(){
        if (typeof window !== 'undefined' && window) {
            return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
        }
        return false;
      },
      yesPayment:function(){
        var str = this.$route.query.id
          str = str+'-'+this.initial+'-'+this.num;
          this.$router.push('lpayment?p='+str);
      },
      getLuggage:function(){
        var that = this;
        var id = this.$route.query.id
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/luggage/getLuggageDetail',
          data:{
            id:id
          },
          dataType:'json',
          success:function(data){
            that.setLuggage = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
      getPurpose:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/luggage/purpose',
          dataType:'json',
          success:function(data){
            that.setPurpose = data.data;
            if(data.data.length > 0){
              that.initial = data.data[0].id
            }
            that.fullscreenLoading = false;
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data;
          that.getLuggage();
          that.getPurpose();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .ldetailApp{
    max-width:640px;
    background:#F1F2F5;
    margin:0 auto;
  }

  .ldetailApp .banner{
    background:#fff;
    font-size:0;
  }
  .ldetailApp .banner .swiper-pagination{
    bottom:30px
  }
  .ldetailApp .banner .swiper-pagination span{
    width:5px;
    height:5px;
    border-radius:5px;
  }
  .ldetailApp .banner .swiper-pagination span.swiper-pagination-bullet-active{
    width:15px;
    background:#fff;
    opacity:1
  }
  .ldetailApp .proCon{
    background:#fff;
    width:100%;
    padding-bottom:12px;
    margin-bottom:12px
  }
  .ldetailApp .proCon .cost{
    height:60px;
    width:100%;
    background:#FF8544;
    position:relative;
  }
  .ldetailApp .proCon .cost .hot{
    position:absolute;
    width:58%;
    height:85px;
    top:-25px;
    background:#FF4444;
    left:0;
    z-index:9;
    border-radius: 10px 88px 0 0;
  }
  .ldetailApp .proCon .cost .hot h1{
    color:#fff;
    font-size:18px;
    padding:10px 0 10px 12px
  }
  .ldetailApp .proCon .cost .hot p{
    padding-left:12px;
    height:30px;
  }
  .ldetailApp .proCon .cost p span{
    float:left
  }
  .ldetailApp .proCon .cost p span:first-child{
    font-size:20px;
    color:#fff;
    margin-right:12px;
    line-height:30px;
  }
  .ldetailApp .proCon .cost p span:first-child font{
    font-size:14px
  }
  .ldetailApp .proCon .cost p span:last-child{
    font-size:13px;
    background:#fff;
    color:#FF4444;
    padding:5px 8px;
    border-radius: 20px;
    vertical-align: top;
  }
  .ldetailApp .proCon .cost .timer{
    float:right;
    margin-right:12px
  }

  .ldetailApp .proCon .cost .timer p{
    color:#fff;
    font-size:14px;
    padding:5px 0;
    text-align:center;
  }
  .ldetailApp .proCon .cost .timer a{
    display:block;
    font-size:14px;
    background:#fff;
    color:#FF4444;
    width:100px;
    height:25px;
    line-height:25px;
    border-radius: 20px;
    text-align:center;
    margin:0 auto
  }

  .ldetailApp .proCon h2{
    width:94%;
    margin:0 auto 10px auto;

  }
  .ldetailApp .proCon h2 .names{
    font-size:22px;
    padding:20px 0 15px 0
  }
  .ldetailApp .proCon h2 p{
    font-size:15px;
    font-weight:normal;
    color:#969799
  }
  .ldetailApp .proCon h2 p span{
    padding-left:15px
  }

  .ldetailApp .norm{
    background:#fff;
    margin-bottom:12px;
  }
  .ldetailApp .norm h2{
    width:94%;
    margin:0 auto;
    font-size:16px;
    padding:15px 0
  }
  

  .ldetailApp .infoCon{
    background:#fff;
    margin-bottom:12px
  }
  .ldetailApp .infoCon h2{
    width:94%;
    margin:0 auto;
    font-size:16px;
    padding:15px 0
  }
  .ldetailApp .infoCon h2 a{
    float:right;
    font-weight:normal;
    color:#969799
  }
  .ldetailApp .infoCon .el-timeline{
    width:92%;
    margin:0 auto;
  }
  .ldetailApp .infoCon .el-timeline .el-timeline-item__node{
    background:#fff;
    width:15px;
    height:15px;
    left:-3px
  }
  .ldetailApp .infoCon .el-timeline .el-timeline-item__node .el-icon-success{
    font-size:16px;
    color:#00A870;
  }
  .ldetailApp .infoCon .el-timeline .el-timeline-item__node .el-icon-error{
    font-size:16px;
    color:#E34D59;
  }
  .ldetailApp .infoCon .el-timeline .el-timeline-item__tail{
    border-color:#ccc;
    border-width:1px
  }
  .ldetailApp .infoCon .el-timeline .el-timeline-item__timestamp{
    font-size:14px;
    color:#3C485C;
    padding-top:4px;
    margin-bottom:15px
  }
  .ldetailApp .infoCon .el-timeline .initial{
    margin-bottom:8px;
    padding:15px;
    background:#F1F2F5;
    border-radius:8px;
    position: relative;
  }
  .ldetailApp .infoCon .el-timeline .initial:last-child{
    margin-bottom:0;
    border-bottom:none
  }
  .ldetailApp .infoCon .el-timeline .initial h4{
    padding-bottom:6px;
    color:#000;
    font-size:15px;
  }
  .ldetailApp .infoCon .el-timeline .initial p{
    font-size:14px;
    color:#666
  }
  .ldetailApp .infoCon .el-timeline .initial em{
    position: absolute;
    top:50%;
    right:4%;
    transform: translateY(-50%);
    width:20px;
    height:20px;
    border-radius:50%;
    text-align:center;
    line-height:20px;
  }
  .ldetailApp .infoCon .el-timeline .initial em.borders{
    border:solid 1px #333
  }
  .ldetailApp .infoCon .el-timeline .initial em.el-icon-check{
    font-size:15px;
    color:#fff;
    border:solid 1px #00A870;
    background:#00A870;
  }

  .ldetailApp .infoCon .xc{
    width:94%;
    margin:0 auto;
    min-height:160px
  }
  .ldetailApp .infoCon img{
    width:100%;
    display:block;
  }

  .ldetailApp .proFooter{
    width: 100%;
    height: 55px;
    background:#fff;
    position:fixed;
    bottom:0;
    border-top:solid 1px rgba(102,102,102,0.1);
    left:0;
    z-index:999
  }
  .ldetailApp .proFooter .left{
    float:left;
    width:40%;
    height:40px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-top:7px
  }
  .ldetailApp .proFooter .left p{
    width:30%;
    position:relative;
  }
  .ldetailApp .proFooter .left p i{
    display:block;
    text-align:center;
    font-size:20px;
    color:#646566
  }
  .ldetailApp .proFooter .left p span{
    display:block;
    text-align:center;
    font-size:13px;
    color:#646566
  }
  .ldetailApp .proFooter .left p em{
    position:absolute;
    width:14px;
    height:14px;
    background:#ee0a24;
    font-size:10px;
    border-radius:50%;
    color:#fff;
    font-style:normal;
    text-align:center;
    line-height:14px;
    top:-5px;
    left:58%
  }
  .ldetailApp .proFooter .right{
    float:right;
    margin-right:3%;
    height:40px;
    margin-top:7px
  }
  .ldetailApp .proFooter .right a{
    width:160px;
    height:40px;
    display:inline-block;
    text-align:center;
    line-height:40px;
    color:#fff;
  }
  .ldetailApp .proFooter .right a:last-child{
    border-radius:40px;
    background:#ff4444
  }

  .ldetailApp .el-drawer{
    border-radius:20px 20px 0 0;
  }
  .ldetailApp .proList{
    width:100%;
    margin:0 auto;
    padding:10px 0 15px 0;
  }
  .ldetailApp .proList dd{
    position: relative;
    background:#fff;
    padding:12px 12px 0 12px;
    border-radius:6px;
  }
  .ldetailApp .proList dd .el-icon-close{
    position:absolute;
    top:5px;
    right:4%;
    font-size:20px
  }
  .ldetailApp .proList dd:last-child{
    border-bottom:none;
  }
  .ldetailApp .proList dd:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .ldetailApp .proList .fmt{
    float:left;
    width:26%;
    font-size:0
  }
  .ldetailApp .proList .right{
    float:left;
    width:72%;
    margin-left:2%;
    position: relative;
    height:85px
  }
  .ldetailApp .proList .right h2{
    font-size:16px;
    color:#000;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    width:82%
  }

  .ldetailApp .proList .right .sales{
    font-size:14px;
    color:#999;
    padding:10px 0
  }
  .ldetailApp .proList .right .price{
    font-weight:bold;
    color:#F20000;
    font-size:14px
  }
  .ldetailApp .proList .right .price font{
    color:#999;
    font-weight:normal;
    font-size:12px;
    text-decoration: line-through;
    padding-left:8px
  }

  .ldetailApp .norm{
    background:#fff;
  }
  .ldetailApp .norm h2{
    width:92%;
    margin:0 auto;
    font-size:16px;
    padding:15px 0
  }
  .ldetailApp .norm ul{
    width:94%;
    margin:0 auto;
  }
  .ldetailApp .norm ul:after{
    display:block;
    clear:both;
    content:"";
    visibility:hidden;
    height:0
  }
  .ldetailApp .norm ul li{
    width:85px;
    height:30px;
    background: #F1F2F5;
    font-size:14px;
    float:left;
    border-radius:5px;
    line-height:30px;
    text-align:center;
    margin-right:12px;
    margin-bottom:15px;
    color: #1C222B;
  }
  .ldetailApp .norm ul li.curt{
    color:#ff4444;
    font-weight:bold;
    background: #FFF2F2;
  }

  .ldetailApp .norm .addnum{
    width:92%;
    margin:0 auto;
    height:26px;
    padding:20px 4%
  }
  .ldetailApp .norm .addnum font{
    float:left;
    color:#000;
    font-weight:bold;
    font-size:16px;
  }
  .ldetailApp .norm .addnum .cnum{
    float:right
  }
  .ldetailApp .norm .addnum .el-icon-remove-outline{
    font-size:26px;
    color:#969799
  }
  .ldetailApp .norm .addnum .el-icon-circle-plus{
    font-size:26px;
    color:#FF2442
  }
  .ldetailApp .norm .addnum .num{
    padding:0 8px;
    vertical-align: top;
    line-height:28px;
    font-size:17px;
    color:#969799
  }
  .ldetailApp .btnYes{
    width:80%;
    margin:0 auto;
    position:absolute;
    bottom:50px;
    left:10%
  }
  .ldetailApp .btnYes a{
    background:#ff4444;
    color:#fff;
    text-align:center;
    height:50px;
    line-height:50px;
    border-radius:50px;
    display:block;
  }


  .ldetailApp .common{
    width:100%;
    margin:0 auto;
  }
  .ldetailApp .common .el-divider__text{
    background:#F1F2F5;
    font-size:16px;
    color:#3C485C
  }
  .ldetailApp .common .el-icon-star-on{
    color:#E34D59
  }
  .ldetailApp .common ul{
    width:94%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin:0 auto;
  }
  .ldetailApp .common ul li{
    width:48.5%;
    background:#fff;
    border-radius: 6px;
    margin-bottom:12px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3);
    position: relative;
  }
  .ldetailApp .common ul li img{
    border-radius: 6px 6px 0 0;
  }
  .ldetailApp .common ul li .conTitle{
    width:92%;
    margin:0 auto;
  }
  .ldetailApp .common ul li .conTitle span{
    font-size:15px;
    font-weight:bold;
    color: #1C222B;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    margin-top:2px
  }
  .ldetailApp .common ul li .conTitle .price{ 
    color: #F20000;
    font-size: 15px;
    font-weight: bold;
    padding-top:6px
  }
  .ldetailApp .common ul li .conTitle .price font {
    color: #999;
    font-size: 12px;
    padding-left: 5px;
    font-weight: normal;
    text-decoration: line-through;
  }
  .ldetailApp .common ul li .conTitle p{
    font-size: 12px;
    color: #666;
    padding:6px 0 10px 0
  }
  .ldetailApp .common ul li i{
    position: absolute;
    width:30px;
    height:30px;
    background:rgba(255, 0, 0, .6);
    color:#fff;
    border-radius: 50%;
    font-size:18px;
    text-align:center;
    line-height:32px;
    bottom:8px;
    right:4%;
    font-weight: bold;
  }
</style>
